import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    NotificationsComponent,
    NotificationDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class NotificationsModule { }
